export default __webpack_public_path__ + "static/firefighters-88eeb1fe909a7eeb759e15dc995e972f.png";